var render = function render(){var _vm=this,_c=_vm._self._c;return _c('small',{style:(_vm.input_style)},[_c('span',{style:(_vm.length > _vm.limit - 10 ? 'color: #e74a3b;' : '')},[_vm._v(_vm._s(_vm.length))]),_vm._v(" / "+_vm._s(_vm.limit)+" "+_vm._s(!_vm.hidden_text ? _vm.getTranslations('expression_655') : '')+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }